import styled from "styled-components";


export const Container = styled.footer`
  background-color: var(--terminal-header);
  border-top: 1px solid var(--terminal-border);
  padding: 0.5rem 2rem;
  margin-top: 15rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: 'Fira Code', monospace;
  font-size: 1.2rem;
  color: #d1d5db;
  position: relative;
  width: 100%;

  .footer-left, .footer-right {
    display: flex;
    align-items: center;
    gap: 2rem;
  }

  .git-branch {
    color: var(--green);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    &::after {
      content: "";
      width: 1px;
      height: 1.2rem;
      background: var(--terminal-border);
      margin-left: 1rem;
    }
  }

  .tech-stack, .version, .uptime {
    opacity: 0.8;
  }

  .footer-center {
    p {
      letter-spacing: 0.1rem;
      font-size: 1.2rem;
      opacity: 0.7;
    }
  }

  .social-media {
    display: flex;
    align-items: center;
    gap: 1.5rem;

    img {
      width: 1.8rem;
      filter: grayscale(1) brightness(0.8);
      transition: 0.25s;
      
      &:hover {
        filter: grayscale(0) brightness(1);
        transform: translateY(-2px);
      }
    }
  }

  @media(max-width: 800px) {
    flex-direction: column;
    padding: 2rem;
    gap: 1.5rem;
    text-align: center;
    
    .footer-left, .footer-right {
      justify-content: center;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .git-branch::after {
      display: none;
    }
  }
`